import {createSelector} from 'reselect'
import selectorsGenerator from '../comments/selectorsGenerator'
import {getCustomers} from '../../entities/selectors'

const getCustomerPanelState = state => state.panels.customer

export const getOpenCustomerId = state => getCustomerPanelState(state).openCustomerId
export const isAllProjectsAssigned = state => getCustomerPanelState(state).allProjectsAssigned
export const isCommentsReadOnly = state => !isAllProjectsAssigned(state)
export const canManage = state => getCustomerPanelState(state).canManage

const commentsSelector = selectorsGenerator(getCustomerPanelState)

export const getComments = commentsSelector.getComments
export const getUsers = commentsSelector.getUsers
export const getCommentsCount = commentsSelector.getCommentsCount
export const getAllCommentsUserIds = commentsSelector.getAllCommentsUserIds
export const getRecentlyAddedCommentsIds = commentsSelector.getRecentlyAddedCommentsIds
export const needMoreComments = commentsSelector.needMoreComments
export const isNewCommentsOnTop = commentsSelector.isNewCommentsOnTop
export const getNewestCommentId = commentsSelector.getNewestCommentId
export const getCommentsScrollTo = commentsSelector.getCommentsScrollTo
export const getEditingCommentId = commentsSelector.getEditingCommentId
export const getEditingCommentText = commentsSelector.getEditingCommentText
export const isCommentsLoading = commentsSelector.isLoading
export const isSendingComment = commentsSelector.isSendingComment
export const getUpdatingCommentId = commentsSelector.getUpdatingCommentId
export const getNewCommentsTexts = commentsSelector.getNewCommentsTexts

export const getCustomerNewComment = createSelector(
    getOpenCustomerId,
    commentsSelector.getNewCommentsTexts,
    (taskId, comments) => comments[taskId] ? comments[taskId] : ''
)

export const isShowNewCommentInput = createSelector(
    commentsSelector.isShowNewCommentInput,
    getOpenCustomerId,
    commentsSelector.getNewCommentsTexts,
    (showInput, customerId, comments) => showInput || comments[customerId] !== undefined
)

const getOpenCustomer = createSelector(
    getOpenCustomerId,
    getCustomers,
    (id, customers) => {
        return (customers[id]) ? customers[id] : null
    }
)

export const getOpenCustomerName = createSelector(
    getOpenCustomer,
    (customer) => {
        return customer ? customer.name : ''
    }
)

export const isPanelOpenedFromUrl = createSelector(
    getCustomerPanelState,
    panelState => panelState.openedFromUrl
)



// WEBPACK FOOTER //
// ./web/js/panels/customer/selectors.js